
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";

@Component
export default class Convenios extends Mixins(FormValidator) {
  private comercios: Array<any> = [];
  private nombreWeb: any = "";
  private nombreCategoria: any = "";
  private logoCategoria: any = "";
  private mostrar: any = null;
  private currentPage = 1;
  private total = 0;

  @Watch("currentPage")
  private currentPageWatch(newValue: any) {
    if (newValue >= 0 && newValue <= Math.ceil(this.total / 8)) {
      // this.getInfoNoticia();
      this.getInfoComercios();
    }
  }

  private mounted() {
    if (
      this.$router.currentRoute.params.nombre &&
      this.$router.currentRoute.params.nombre != ""
    ) {
      this.nombreWeb = this.$router.currentRoute.params.nombre;
      this.getInfoComercios();
    }
  }

  private getInfoComercios() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get(
        "/listado/convenios?nombre_web=" +
          this.nombreWeb +
          "&pagina=" +
          this.currentPage
      )
      .then((res: any) => {
        let base = process.env.VUE_APP_BASE_URL;
        this.comercios = res.data.convenios;
        this.total = res.data.total;
        if (this.comercios.length == 0) {
          this.mostrar = true;
        }
        this.nombreCategoria = res.data.nombre_categoria;
        // this.logoCategoria = base + res.data.logo_categoria;
        for (let i = 0; i < this.comercios.length; i++) {
          if (this.comercios[i].logo != null && this.comercios[i].logo) {
            this.comercios[i].logo = base + this.comercios[i].logo;
          } else {
            this.comercios[i].logo = require("@/assets/logos/logo-default.png");
          }
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
      });
  }

  private irBeneficio(idComercio: any, nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "Beneficio" &&
      this.$router.currentRoute.params.name == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "Beneficio",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
}
